<div class="step-panel">

  <div class="pg-title">
    Consent capture 
    <span class="badge b-r" style="vertical-align:middle;margin-left:8px">
      P0 Regulatory
    </span>
  </div>

  <div class="pg-sub">
    Must be completed by borrower on their own device. Timestamped + IP-logged per DPDP Act 2023 and RBI KYC Directions 2016.
  </div>

  <div class="alert err">
    <span style="flex-shrink:0">⚠</span>
    <span>
      <strong>Admin must NOT tick these on behalf of the borrower.</strong> 
      Send the consent link to borrower's mobile. All 3 consents must be recorded before bureau pull can be triggered.
    </span>
  </div>

  <div class="g2">

    <!-- LEFT -->
    <div>

      <div class="consent-wrap">
        <div class="cw-title">
          Borrower consent — on borrower's device only
        </div>

        <div class="cw-body">
          I / we authorise Nishwik Financial Services and its lending partners to collect, process, store and share my personal, financial, and KYC data for loan evaluation under the Digital Personal Data Protection Act 2023.
        </div>

        <label class="c-check">
          <input type="checkbox" class="cbx" [(ngModel)]="c1">
          <span class="c-lbl">
            I consent to processing of my personal data for loan evaluation under DPDP Act 2023.
          </span>
        </label>

        <label class="c-check">
          <input type="checkbox" class="cbx" [(ngModel)]="c2">
          <span class="c-lbl">
            I authorise Nishwik to pull my credit bureau report (Equifax / CRIF / Experian) for credit assessment. This is a hard enquiry.
          </span>
        </label>

        <label class="c-check">
          <input type="checkbox" class="cbx" [(ngModel)]="c3">
          <span class="c-lbl">
            I authorise access to my bank account data via Account Aggregator (AA) framework for income and cashflow verification.
          </span>
        </label>

        <div class="c-meta">
          <span>Timestamp: <span>{{ timestamp || 'Pending' }}</span></span>
          <span>IP: <span>{{ ip || 'Pending' }}</span></span>
          <span>Agent: {{ userLoginService.User()?.userName || 'System' }}</span>
          <span>App: {{ applicationData?.lmsApplicationName || 'NWK-' + applicationData?.applicationId }}</span>
        </div>
      </div>

      <div style="display:flex;gap:8px;flex-wrap:wrap">
        <button class="btn btn-pri" (click)="sendConsentLink()">
          Send consent link
        </button>

        <button class="btn btn-sec btn-sm" (click)="submitConsent()" [disabled]="!allChecked || isSubmitting">
          <span *ngIf="!isSubmitting">Record consent ↗</span>
          <span *ngIf="isSubmitting">Recording...</span>
        </button>
      </div>

    </div>

    <!-- RIGHT -->
    <div>

      <div class="card">
        <div class="card-title">
          <div class="ct-bar"></div>
          Consent status
        </div>

        <div style="display:flex;flex-direction:column;gap:9px">

          <!-- C1 -->
          <div style="background:var(--surf2);border:1px solid var(--bdr);border-radius:var(--r);padding:12px;display:flex;align-items:center;justify-content:space-between">
            <div>
              <div style="font-size:12px;font-weight:600">DPDP data processing</div>
              <div style="font-size:11px;color:var(--txt3);margin-top:1px">
                {{ c1 ? 'Recorded' : 'Pending' }}
              </div>
            </div>
            <span class="badge" [ngClass]="c1 ? 'b-g' : 'b-gray'">
              {{ c1 ? 'Recorded' : 'Pending' }}
            </span>
          </div>

          <!-- C2 -->
          <div style="background:var(--surf2);border:1px solid var(--bdr);border-radius:var(--r);padding:12px;display:flex;align-items:center;justify-content:space-between">
            <div>
              <div style="font-size:12px;font-weight:600">Bureau pull consent</div>
              <div style="font-size:11px;color:var(--txt3);margin-top:1px">
                {{ c2 ? 'Recorded' : 'Pending' }}
              </div>
            </div>
            <span class="badge" [ngClass]="c2 ? 'b-g' : 'b-gray'">
              {{ c2 ? 'Recorded' : 'Pending' }}
            </span>
          </div>

          <!-- C3 -->
          <div style="background:var(--surf2);border:1px solid var(--bdr);border-radius:var(--r);padding:12px;display:flex;align-items:center;justify-content:space-between">
            <div>
              <div style="font-size:12px;font-weight:600">Account Aggregator consent</div>
              <div style="font-size:11px;color:var(--txt3);margin-top:1px">
                {{ c3 ? 'Recorded' : 'Pending' }}
              </div>
            </div>
            <span class="badge" [ngClass]="c3 ? 'b-g' : 'b-gray'">
              {{ c3 ? 'Recorded' : 'Pending' }}
            </span>
          </div>

        </div>

        <div style="margin-top:12px;background:var(--surf3);border-radius:var(--r);padding:10px 13px;font-size:12px;color:var(--txt2)">
          All 3 consents required. Status: {{ applicationData?.applicationStatus }}
        </div>

      </div>

      <!-- SMS BOX -->
      <div class="sms-box" style="margin-top:0">
        <div class="sms-top">SMS to borrower</div>
        <div class="sms-msg">
          Hi {{ applicationData?.userName || userKycData?.name || 'Borrower' }}, please give your consent for Nishwik loan {{ applicationData?.lmsApplicationName || applicationData?.applicationId }}:<br><br>
          <span class="sms-link">https://nishwik.in/consent/{{ applicationData?.applicationId }}</span><br><br>
          30 seconds. Expires in 24 hours.
        </div>
      </div>

    </div>

  </div>

  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="submitConsent()" [disabled]="!allChecked || isSubmitting">
      <span *ngIf="!isSubmitting">All consents recorded → Next →</span>
      <span *ngIf="isSubmitting">Processing...</span>
    </button>
  </div>

</div>